module.exports = __webpack_public_path__ + "static/media/R5.eab0380d.jpg";